var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 62,
    viewBox: "0 0 51 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.369 21.0029H49.0863V60.4322L1.56658 60.4317V21.1381L25.327 1.65145L49.1899 21.225L49.3698 21.0037H49.0871H49.3698L49.5507 20.7842L25.5081 1.06417C25.4049 0.978609 25.2542 0.978609 25.1482 1.06417L1.10561 20.7854L1.00098 21.0049V60.7163L1.08515 60.9172L1.28511 61H49.3715L49.571 60.9172L49.6556 60.7163L49.6547 21.0037L49.5514 20.7842L49.3701 21.0037",
    fill: "#212121",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.369 21.0029H49.0863V60.4322L1.56658 60.4317V21.1381L25.327 1.65145L49.1899 21.225L49.3698 21.0037H49.0871H49.3698L49.5507 20.7842L25.5081 1.06417C25.4049 0.978609 25.2542 0.978609 25.1482 1.06417L1.10561 20.7854L1.00098 21.0049V60.7163L1.08515 60.9172L1.28511 61H49.3715L49.571 60.9172L49.6556 60.7163L49.6547 21.0037L49.5514 20.7842L49.3701 21.0037",
    stroke: "#212121",
    strokeOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28413 21.2863H49.3705C49.5258 21.2863 49.6537 21.1598 49.6537 21.0021C49.6537 20.8464 49.5272 20.718 49.3705 20.718L1.28413 20.7185C1.12881 20.7185 1 20.8459 1 21.0026C0.999536 21.1598 1.12742 21.2863 1.28413 21.2863",
    fill: "#212121",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28413 21.2863H49.3705C49.5258 21.2863 49.6537 21.1598 49.6537 21.0021C49.6537 20.8464 49.5272 20.718 49.3705 20.718L1.28413 20.7185C1.12881 20.7185 1 20.8459 1 21.0026C0.999536 21.1598 1.12742 21.2863 1.28413 21.2863",
    stroke: "#212121",
    strokeOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28413 41.0073H49.3705C49.5258 41.0073 49.6537 40.8813 49.6537 40.7246C49.6537 40.5679 49.5272 40.4414 49.3705 40.4414H1.28413C1.12881 40.4414 1 40.5679 1 40.7246C0.999536 40.8795 1.12742 41.0073 1.28413 41.0073",
    fill: "#212121",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28413 41.0073H49.3705C49.5258 41.0073 49.6537 40.8813 49.6537 40.7246C49.6537 40.5679 49.5272 40.4414 49.3705 40.4414H1.28413C1.12881 40.4414 1 40.5679 1 40.7246C0.999536 40.8795 1.12742 41.0073 1.28413 41.0073",
    stroke: "#212121",
    strokeOpacity: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1807 21.0027V40.7239C20.1807 40.8787 20.3081 41.0066 20.4648 41.0066C20.6215 41.0066 20.7489 40.8806 20.7489 40.7239L20.7485 21.0027C20.7485 20.8469 20.621 20.7195 20.4643 20.7195C20.3076 20.7199 20.1807 20.8464 20.1807 21.0027",
    fill: "#212121",
    fillOpacity: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1807 21.0027V40.7239C20.1807 40.8787 20.3081 41.0066 20.4648 41.0066C20.6215 41.0066 20.7489 40.8806 20.7489 40.7239L20.7485 21.0027C20.7485 20.8469 20.621 20.7195 20.4643 20.7195C20.3076 20.7199 20.1807 20.8464 20.1807 21.0027",
    stroke: "#212121",
    strokeOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHut);
export default __webpack_public_path__ + "static/media/hut.d42ef4ff7a9394159048314f59d987dd.svg";
export { ForwardRef as ReactComponent };